import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  HostBinding,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: '[whitespace]',
  template: `<div></div>`,
  imports: [CommonModule],
})
export class WhitespaceComponent {
  itemsLength = input.required<number>();
  itemsLength$ = toObservable(this.itemsLength);
  ref = viewChild<ElementRef<HTMLElement>>('whitespace');

  @HostBinding('style.height') get currentHeight() {
    return `${this.height()}px`;
  }

  height = computed(() => this.itemsLength() * 100);
}
